var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.54,
    height: 40,
    fill: "#007cc2",
    viewBox: "0 0 62.54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -92.267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 92.267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.008,104.212V92.267H28.6v11.287H16.411V92.267H0v40H45.008V120.322H31.39v-3.715H45.008v-2.482H31.39v-3.715H45.008v-2.482H31.39v-3.715Z",
    transform: "translate(0 -92.267)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.126 92.267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.757,
    height: 7.572
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.009 104.213)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.531,
    height: 3.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.009 110.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.572,
    height: 3.715
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.009 116.607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.615,
    height: 3.715
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourierIcon);
export default __webpack_public_path__ + "static/media/courierIcon.294732c004aa3e8d550aa99c38938ec7.svg";
export { ForwardRef as ReactComponent };